<h2 mat-dialog-title>{{ data?.title }}</h2>
<mat-dialog-content>
  <p>{{data?.message}}</p>
  <div *ngIf="data.isShow === true">
    <mat-form-field appearance="outline" class="w-100">
      <mat-label>Reason for removal</mat-label>
      <textarea matInput [formControl]="reasonControl" rows="3"></textarea>
      <mat-error *ngIf="reasonControl.invalid">Reason is required.</mat-error>
    </mat-form-field>
  </div>
</mat-dialog-content>

<mat-dialog-actions>
  <button mat-button (click)="dialogRef.close()">Cancel</button>
  <button mat-raised-button color="warn" [disabled]="data.isShow && reasonControl.invalid" (click)="confirm()">Remove</button>
</mat-dialog-actions>
